var DownloadableItems = function () {

    var months = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio',
        'Junho', 'Julho', 'Agosto', 'Setembro',
        'Outubro', 'Novembro', 'Dezembro'
    ];

    var componentID = 0;
    var pagination = {};
    var filters = {};
    var $pluginPage = $("[data-component='pagination'] .pages-holder");

    this.init = function () {

        componentID = $("[data-component='downloadable-item-list']").data("id");

        $.ajax({
            type: "POST",
            url: "/umbraco/surface/DownloadableItems/FirstLoad",
            data: JSON.stringify({ "ComponentID": componentID }),
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8",
            success: function (response) {

                pagination = response.Pagination;

                var categoryList = $("[data-component='filter-bar']").find("#category");

                $.each(response.CategoryList, function (i, item) {
                    categoryList.append($('<option>', {
                        value: item.ID,
                        text: item.Name,
                        class: 'option'
                    }));
                });

                var monthList = $("[data-component='filter-bar']").find("#month");

                $.each(response.MonthList, function (i, item) {
                    monthList.append($('<option>', {
                        value: months[item - 1],
                        text: months[item - 1],
                        class: 'option'
                    }));
                });

                var yearList = $("[data-component='filter-bar']").find("#year");

                $.each(response.YearList, function (i, item) {
                    yearList.append($('<option>', {
                        value: item,
                        text: item,
                        class: 'option'
                    }));
                });

                if (response.DownloadableItemList.length > 0) {
                    getPagination(pagination);
                }
                else {
                    $("[data-component='pagination']").hide();
                }

                addItems(response.DownloadableItemList);
            },
            error: function (e) {

            }
        });

        $("[data-component='pagination'] .arrows-holder .btn-arrow").click(function () {

            if ($(this).hasClass("no-cursor")) {
                return;
            }

            var pageNumber = 0;

            if ($(this).data("direction") === "previous") {
                pageNumber = pagination.CurrentPage - 1;
            }
            else {
                pageNumber = pagination.CurrentPage + 1;
            }

            $("[data-component='pagination'] .page-item.active").removeClass("active");
            $("[data-component='pagination'] .pages-holder .page-item .page:contains(" + pageNumber + ")").parent().click();
        });

        $("#btnSearchDownloadable").click(function () {

            var categoryValue = $("#category").val();
            var monthValue = months.indexOf($("#month").val());
            var yearValue = $("#year").val();

            if (categoryValue === "" && monthValue == -1 && yearValue === "") {
                return;
            }

            pagination.CurrentPage = 1;

            filters = {
                "category": $("#category").val(),
                "month": months.indexOf($("#month").val()),
                "year": $("#year").val()
            };

            loadItems(true);
        });

        $("#clean-filter").click(function () {

            if ($("#category").val() === "" && $("#month").val() === "" && $("#year").val() === "") {
                return;
            }

            $("#category").val("");
            $("#month").val("");
            $("#year").val("");

            filters = {
                "category": $("#category").val(),
                "month": $("#month").val(),
                "year": $("#year").val()
            };

            pagination.CurrentPage = 1;

            loadItems(true);
        });
    }

    var loadItems = function (resetPagination) {

        $("[data-component='downloadable-item-list'] [data-component='downloadable-item']").remove();

        var ajaxLoadTimeout;

        $.ajax({
            type: "POST",
            url: "/umbraco/surface/DownloadableItems/Paginate",
            data: JSON.stringify({ "ComponentID": componentID, "Pagination": pagination, "Filter": filters }),
            dataType: "json",
            async: true,
            contentType: "application/json; charset=utf-8",
            beforeSend: function () {

                ajaxLoadTimeout = setTimeout(function () {
                    $("#firstLoad").show();
                }, 300);
            },
            success: function (response) {

                if (resetPagination) {
                    $pluginPage.twbsPagination("destroy");
                    $pluginPage.empty();
                    $pluginPage.removeData("twbs-pagination");
                    $pluginPage.unbind("page");

                    pagination = response.Pagination;
                    getPagination(pagination);
                }

                addItems(response.DownloadableItemList);
                clearTimeout(ajaxLoadTimeout);
                $("#firstLoad").hide();
            },
            error: function (e) {

            },
            complete: function () {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("[data-component='downloadable-item']").first().offset().top - 25
                }, 500);
            }
        });
    };

    var addItems = function (items) {

        if (items.length == 0) {
            $("#noDownloadableItemFound").show();
        }
        else {
            $("#noDownloadableItemFound").hide();

            var html = '';

            for (var i = 0; i < items.length; i++) {
                html += getDownloadableItem(items[i]);
            }

            $("[data-component='downloadable-item-list']").append(html);

            checkNewTabLinks($("[data-component='downloadable-item'] a"));
        }

        $("#firstLoad").hide();
    };

    var getPagination = function (pagination) {

        if (pagination.PageCount == 0) {
            $("[data-component='pagination']").hide();
            return;
        }
        else {
            $("[data-component='pagination']").show();
        }

        if (pagination.PageCount == 1) {
            $("[data-component='pagination'] .arrows-holder .btn-arrow").addClass("no-cursor");
        }
        else {
            $("[data-component='pagination'] .arrows-holder .btn-arrow[data-direction='previous']").addClass("no-cursor");
            $("[data-component='pagination'] .arrows-holder .btn-arrow[data-direction='next']").removeClass("no-cursor");
        }

        $pluginPage.twbsPagination({
            totalPages: pagination.PageCount,
            visiblePages: 10,
            nextClass: "hidden",
            prevClass: "hidden",
            firstClass: "hidden",
            lastClass: "hidden",
            paginationClass: "pagination-download",
            anchorClass: "page",
            initiateStartPageClick: false,
            onPageClick: function (event, page) {

                pagination.CurrentPage = page;

                $("[data-component='pagination'] .arrows-holder .btn-arrow").removeClass("no-cursor");

                if (pagination.CurrentPage === 1) {
                    $("[data-component='pagination'] .arrows-holder .btn-arrow[data-direction='previous']").addClass("no-cursor");
                }
                else if (pagination.CurrentPage === pagination.PageCount) {
                    $("[data-component='pagination'] .arrows-holder .btn-arrow[data-direction='next']").addClass("no-cursor");
                }

                var firstPage = 0;
                var lastPage = 0;

                firstPage = (pagination.CurrentPage - 1) * pagination.ItemsPerPage + 1;

                if ((pagination.CurrentPage - 1) * pagination.ItemsPerPage + pagination.ItemsPerPage < pagination.TotalEntries) {
                    lastPage = (pagination.CurrentPage - 1) * pagination.ItemsPerPage + pagination.ItemsPerPage;
                }
                else {
                    lastPage = pagination.TotalEntries;
                }

                $("[data-component='pagination'] .total-pages .showing").text(firstPage + " - " + lastPage);
                $("[data-component='pagination'] .total-pages span").last().text(pagination.TotalEntries);

                loadItems(false);
            }
        });

        var firstPage = 0;
        var lastPage = 0;

        if (pagination.TotalEntries > 0) {
            firstPage = 1;
        }

        if (pagination.TotalEntries < pagination.ItemsPerPage) {
            lastPage = pagination.TotalEntries;
        }
        else {
            lastPage = pagination.ItemsPerPage;
        }

        $("[data-component='pagination'] .total-pages .showing").text(firstPage + " - " + lastPage);
        $("[data-component='pagination'] .total-pages span").last().text(pagination.TotalEntries);
    };

    var getDownloadableItem = function (item) {

        var html = '';

        html += '<div data-component="downloadable-item">';
        html += '   <div class="row">';
        html += '       <div class="col-md-12">';
        html += '           <img src="' + item.Thumbnail + '" alt="' + item.ThumbnailAltText + '" title="' + item.ThumbnailAltText + '" class="img">';
        html += '           <div class="content-block">';
        html += '               <div class="text-holder">';
        html += '                   <h4 class="title">' + item.Title + '</h4>';
        html += '                   <div class="description">';
        html += '                       ' + item.Description;
        html += '                   </div>';

        for (var i = 0; i < item.CategoryList.length; i++) {
            html += '               <span class="info">' + item.CategoryList[i] + '</span>';
        }

        html += '                   <span class="info">' + item.Date + '</span>';
        html += '               </div>';
        html += '               <a href="' + item.Link + '" class="btn">Baixar</a>';
        html += '           </div>';
        html += '       </div>';
        html += '   </div>';
        html += '</div>';

        return html;
    };

    return this.init();
}